module.exports = __webpack_public_path__ + "assets/back-arrow-new-ac53d8.svg";